<div *ngIf="reviews.length > 0" class="mt-3 ml-3 service-option">
<div *ngFor="let item of reviews;index as i">
    <app-reviews-line-item [reviewItem]="item"></app-reviews-line-item>
</div>
</div>
<div *ngIf="reviews.length == 0" class="mt-3 service-option">
   <p style="color: #838383 !important;">{{'COMMON.NO_REVIEWS' | translate}}</p> 
</div>